import { render, staticRenderFns } from "./BuyerUsersRegister.vue?vue&type=template&id=d9651754&scoped=true&"
import script from "./BuyerUsersRegister.vue?vue&type=script&lang=js&"
export * from "./BuyerUsersRegister.vue?vue&type=script&lang=js&"
import style0 from "./BuyerUsersRegister.vue?vue&type=style&index=0&id=d9651754&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9651754",
  null
  
)

export default component.exports